export default __webpack_public_path__ + "static/media/OpenSans-SemiBoldItalic.63afadba.ttf";